import type { Size } from './types.js';

// Visual margin from any edge of the placard to the lettering.
export const MARGIN_DEFAULT_IN = 0.25;
export const MARGIN_COMPACT_IN = 0.125; // applies when either dim is 1"

// Fixed vertical gap between stacked text lines, in inches.
export const LINE_GAP_IN = 0.22;
export const LINE_GAP_COMPACT_IN = 0.125; // for placards with a short side ≤ 2"

// Small tier is ~45% of large tier's height. Not a hard rule; tuned for
// visual hierarchy on real patches (e.g., "POLICE" large + "K9" small).
export const SMALL_TO_LARGE_RATIO = 0.45;

// Inter Black cap-height-to-em ratio. Used by renderers to convert from
// spec-level "cap height" percentages to CSS/Pixi font-size.
export const CAP_TO_EM = 0.73;

export function marginInchesFor(size: Size): number {
  // Tight margin for compact placards (either dimension ≤ 2"); default otherwise.
  const shortSide = Math.min(size.width, size.height);
  return shortSide <= 2 ? MARGIN_COMPACT_IN : MARGIN_DEFAULT_IN;
}

export function lineGapInchesFor(size: Size): number {
  const shortSide = Math.min(size.width, size.height);
  return shortSide <= 2 ? LINE_GAP_COMPACT_IN : LINE_GAP_IN;
}

export function maxLinesFor(size: Size): number {
  // 1" tall/wide panels cannot fit multiple lines with readable text.
  return size.width === 1 || size.height === 1 ? 1 : 3;
}
